import { IconBase } from "./iconBase.js";
import { Fragment, jsx, jsxs } from "@emotion/react/jsx-runtime";
//#region src/door.tsx
var Door = ({ type, ...rest }) => /* @__PURE__ */ jsx(IconBase, {
	viewBox: "0 0 24 24",
	...rest,
	children: type === "stroke" ? /* @__PURE__ */ jsxs(Fragment, { children: [
		/* @__PURE__ */ jsx("path", {
			d: "M3 19.8H6M6 19.8L15 21V3L6 4.8V19.8Z",
			stroke: "currentColor",
			strokeWidth: "1.5",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M15 6H18.6V19.8H21",
			stroke: "currentColor",
			strokeWidth: "1.5",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M12 12.0005V13.2005",
			stroke: "currentColor",
			strokeWidth: "1.5",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	] }) : /* @__PURE__ */ jsx("path", {
		d: "M14.8525 2.26465C15.0729 2.22058 15.3018 2.27747 15.4756 2.41992C15.6493 2.56237 15.75 2.77532 15.75 3V5.25H18.5996C19.0138 5.25 19.3496 5.58579 19.3496 6V19.0498H21C21.4141 19.0498 21.7499 19.3857 21.75 19.7998C21.75 20.214 21.4142 20.5498 21 20.5498H18.5996C18.1856 20.5496 17.8496 20.2139 17.8496 19.7998V6.75H15.75V21C15.75 21.2162 15.6568 21.422 15.4941 21.5645C15.3315 21.7069 15.1147 21.7717 14.9004 21.7432L5.95117 20.5498H3C2.58579 20.5498 2.25 20.214 2.25 19.7998C2.25011 19.3857 2.58585 19.0498 3 19.0498H5.25V4.7998C5.25009 4.44249 5.50221 4.13468 5.85254 4.06445L14.8525 2.26465ZM12 11.25C11.5859 11.25 11.2503 11.586 11.25 12V13.2002C11.2501 13.6143 11.5859 13.9502 12 13.9502C12.4141 13.9502 12.7499 13.6143 12.75 13.2002V12C12.7497 11.586 12.4141 11.25 12 11.25Z",
		fill: "currentColor"
	})
});
//#endregion
export { Door };
